module.exports = __webpack_public_path__ + "resources/img/certi_iso_iec_27001_m.4e35ad4b7d18dcf50de9fcf700558c99.png";